var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTick = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#001E3C",
  d: "M9.99 17.26a.47.47 0 0 1-.35-.15l-4.98-5a.51.51 0 0 1 0-.71.5.5 0 0 1 .71 0l4.62 4.64 9.6-9.64c.2-.2.51-.2.71 0s.2.51 0 .71l-9.93 9.96-.03.04c-.1.1-.22.15-.35.15"
})));
export { SvgTick as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYTZiNzdmMzU2MWMxMmUyMjNiN2YzYjBlNzU5NmM0ZWYuc3ZnIjs=";